import { HttpClient } from '@angular/common/http';
import { Component, inject, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-svg-component',
  templateUrl: './svg-component.component.html',
  styleUrls: ['./svg-component.component.css']
})
export class SvgComponentComponent {
  @Input() src: string = '';
  @Input() fill: string = '';
  @Input() stroke: string = '';
  svgContent: SafeHtml | null = null;

  private readonly http: HttpClient = inject(HttpClient);
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);

  ngOnInit() {
    if (this.src) {
      this.http.get(this.src, { responseType: 'text' }).subscribe(rawSvg => {
        let updatedSvg = rawSvg;

        if (this.fill) {
          updatedSvg = updatedSvg.replace(/fill=".*?"/g, `fill="${this.fill}"`);
        }

        if (this.stroke) {
          updatedSvg = updatedSvg.replace(
            /stroke=".*?"/g,
            `stroke="${this.stroke}"`
          );
        }

        this.svgContent = this.sanitizer.bypassSecurityTrustHtml(updatedSvg);
      });
    }
  }
}
